module.exports = __webpack_public_path__ + "static/img/button6.cc7b082.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/button6.png
// module id = LV1d
// module chunks = 4